import { AutopilotRule } from "./rule";
import { Subject } from "rxjs";

export abstract class AutopilotRepository {
  ruleCreated: Subject<AutopilotRule>;
  ruleUpdated: Subject<AutopilotRule>;

  getRule: (id: string) => Promise<AutopilotRule>;

  createRule: (rule: AutopilotRule) => Promise<void>;

  updateRule: (rule: AutopilotRule) => Promise<void>;

  getAllRules: () => Promise<AutopilotRule[]>;

  //getAllVideoRules: () => Promise<AutopilotRule[]>;

  setActiveState: (ruleId: string, isActive: boolean) => Promise<void>;

  markDeleted: (ruleId: string) => Promise<void>;
}
